﻿jQuery(document).ready(function ($) {
  // JS BACK

  $('[data-back]').click(function (event) {
    if (
      document.referrer &&
      document.referrer.indexOf($(this).attr('href')) !== -1
    ) {
      event.preventDefault();
      history.back();
    }
  });

  // B-LINK ARROW SVG

  $('.b-link-arrow').append(
    '<svg width="7px" height="10px" viewBox="0 0 7 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
      '<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
      '<g id="Icons/icon-arrow-right" transform="translate(-13.000000, -11.000000)" stroke="#695BD2" stroke-width="2">' +
      '<polyline id="icon-arrow-small-copy-3" points="14 12 18 16.5 14 21"></polyline>' +
      '</g>' +
      '</g>' +
      '</svg>'
  );

  // DISABLE SCROLL

  function disableScroll() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'b-scrollbar';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    $('body').css({ overflow: 'hidden' });
    $('.b-page').css({ 'border-right-width': scrollbarWidth + 'px' });
    $('.b-page-head, .b-nav, .b-modal').css({ right: scrollbarWidth + 'px' });
  }

  // ENABLE SCROLL

  function enableScroll() {
    $('body').removeAttr('style');
    $('.b-page').removeAttr('style');
    $('.b-page-head, .b-nav, .b-modal').removeAttr('style');
  }

  // STOP PAGE SCROLL WHEN NAV OPEN

  $('#toggle-nav').change(function () {
    if ($('#toggle-nav').prop('checked')) {
      if ($(document).scrollTop() < $('.b-page-head').height())
        $(document).scrollTop(0);
      $('.NAV .frame').scrollTop(0);
      disableScroll();
    } else {
      setTimeout(function () {
        enableScroll();
      }, 250);
    }
  });

  // STOP PAGE SCROLL WHEN MODAL OPEN

  $('#toggle-modal').change(function () {
    if ($('#toggle-modal').prop('checked')) {
      $('#toggle-nav').prop('checked', false);
      $('.MODAL .container').scrollTop(0);
      disableScroll();
    } else {
      setTimeout(function () {
        $('.b-modal .container').html('');
        $('.b-modal .frame').removeAttr('style');
        enableScroll();
      }, 250);
    }
  });

  // LOAD MODAL

  $(document).on('click', '[data-modal]', function (event) {
    var modal = $('#' + $(this).attr('data-modal'));
    if (modal.length) {
      $('.b-modal .container').html(
        modal.html().replace('autoplay=0', 'autoplay=1')
      );
      if ($(this).attr('data-modal-width'))
        $('.b-modal .frame').css({ width: $(this).attr('data-modal-width') });
    } else {
      event.preventDefault();
    }
  });

  // SMOOTH SCROLL ON ACHORS

  //$('a[href*="#"]').on('click', function (event) {

  //  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
  //    && location.hostname == this.hostname && $(this.hash).length)
  //  {
  //    event.preventDefault();

  //    if ($(this).parents('.b-nav')) {
  //      $('#toggle-nav').prop('checked', false);
  //      enableScroll();
  //    }

  //    $('html, body').animate({ scrollTop: $(this.hash).offset().top }, 500, function () {
  //      $('.b-page').removeAttr('data-scroll');
  //    });
  //  }
  //});

  // STICKY SCROLL CHECK

  var page = $('.b-page');
  var pageHead = $('.b-page-head');
  var previousScrollPosition = $(document).scrollTop();

  $(document).scroll(function () {
    var currentScrollPosition = $(document).scrollTop();

    if (currentScrollPosition > pageHead.height()) {
      page.attr(
        'data-scroll',
        currentScrollPosition < previousScrollPosition ? 'up' : 'down'
      );
    }

    if (currentScrollPosition < 1) {
      page.removeAttr('data-scroll');
    }

    previousScrollPosition = currentScrollPosition;
  });
});

jQuery(window).on('load', function () {
  jQuery(window).trigger('resize');
  jQuery(document).trigger('scroll');
});
